import isNull from 'lodash/isNull';
import isUndefined from 'lodash/isUndefined';

export const formatMoney = (value, keepDecimals = false) => {
	value = !isNull(value) && !isUndefined(value) ? value.toString() : '';

	// Remove all chars except numbers and .
	value = value.replace(/[^0-9.-]/g, '');

	// Create an array with sections split by .
	const sections = value.split('.');
	let res;

	// Remove any leading 0s apart from single 0
	if (sections[0] !== '0' && sections[0] !== '00') {
		sections[0] = sections[0].replace(/^0+/, '');
	} else {
		sections[0] = '0';
	}

	// If numbers exist after first .
	if (sections[1] && !!keepDecimals) {
		// Join first two sections and truncate end section to length 2 only if decimals are not .00
		res = sections[1].slice(0, 2) === '00' ? sections[0] : sections[0] + '.' + sections[1].slice(0, 2);
		// If original value had a decimal place at the end, add it back
	} else if (value.indexOf('.') !== -1 && !!keepDecimals) {
		res = sections[0] + '.';
		// Otherwise, return only section
	} else {
		res = sections[0];
	}

	return res.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
};

export const formatTime = (value, oldValue) => {
	const newNumberValue = value ? value.toString() : '';
	const hours = newNumberValue.split(':')[0];
	const minutes = newNumberValue.split(':')[1] || '';

	if (newNumberValue && !Number(newNumberValue.replace(':', ''))) {
		return oldValue;
	}
	if (newNumberValue.length > 5) {
		return oldValue;
	}
	if (Number(hours) > 23 || Number(minutes) > 60) {
		return `${Number(hours) > 23 ? 23 : hours}:${Number(minutes) > 60 ? 59 : minutes}`;
	}
	if (newNumberValue.length === 2 && oldValue.toString().length === 1) {
		return `${value}:`;
	}

	return value;
};

export const formatYearMonth = (value, oldValue) => {
	const lengthNew = value && value.length || 0;
	const lengthOld = oldValue && oldValue.length || 0;
	if (lengthOld > lengthNew) {
		return value;
	}
	if (lengthNew < 4) {
		return Number(value) ? value : oldValue;
	}
	if (lengthNew === 4) {
		return Number(value) > 2000 && Number(value) < 3000 ? `${value}-` : oldValue;
	}
	if (lengthNew > 4) {
		return value.split('-')[1] && Number(value.split('-')[1]) <= 12 ? value : oldValue;
	}
	if (lengthNew > 7) {
		return oldValue;
	}
};


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/format.js